import './NavigationSidebar.module.css';

import { Button, Container, Navbar } from 'react-bootstrap';
import { IconButton, Typography, } from '@mui/material'
import React, { useEffect, useRef, useState } from 'react';
import { close, open } from '../../redux/navSlice';

import ArrowRightAltOutlinedIcon from '@mui/icons-material/ArrowRightAltOutlined';
import Cookies from 'js-cookie';
import ListAltIcon from '@mui/icons-material/ListAlt';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import { NavLink } from "react-router-dom";
import Popover from '@mui/material/Popover'
import admincompany from '../../assets/images/admincompany.svg'
import adminreporticon from '../../assets/images/admincompany.svg'
import auditIcon from '../../assets/images/trace.svg'
import bannercontenticon from '../../assets/images/banner-menu-icon.svg'
import buUniticons from '../../assets/images/buunit.svg'
import companyprofileicon from '../../assets/images/partner.svg'
import dashbordHovered from '../../assets/images/Home.svg'
import dashbordicon from '../../assets/images/Home.svg'
import logouticon from '../../assets/images/logout.svg'
import ordersicon from '../../assets/images/orders-green.svg'
import partnerProfileIcon from '../../assets/images/partnerProfileIcon.svg'
import processlosicon from '../../assets/images/processloss.svg'
import producticon from '../../assets/images/product.svg'
import requesttagicon from '../../assets/images/tag.svg'
import shipmenticon from '../../assets/images/shipment.svg'
import sourceverificationicon from '../../assets/images/verification.svg'
import stockicon from '../../assets/images/stock.svg'
import tracebilityicon from '../../assets/images/trace.svg'
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import usersicon from '../../assets/images/users.svg'
const SidebarPopoverItem = ({ icon, label, menuItems }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const handlePopoverOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handlePopoverClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);

    return (
        <>
            <IconButton
                aria-owns={open ? 'mouse-over-popover' : undefined}
                aria-haspopup="true"
                onMouseEnter={handlePopoverOpen}
                onMouseLeave={handlePopoverClose}
            >
                {icon}
            </IconButton>
            <Popover
                id="mouse-over-popover"
                sx={{
                    pointerEvents: 'none', // Prevents the popover from closing when the user tries to click on its content
                }}
                open={open}
                anchorEl={anchorEl}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}
                onClose={handlePopoverClose}
                disableRestoreFocus
                onMouseEnter={handlePopoverOpen} // Keep popover open when mouse enters popover content
                onMouseLeave={handlePopoverClose} // Close popover when mouse leaves popover content
            >
                <Typography sx={{ p: 2 }}>
                    {menuItems.map((item, index) => (
                        <NavLink key={index} to={item.path} style={{ textDecoration: 'none', color: 'inherit' }}>
                            {item.label}
                        </NavLink>
                    ))}
                </Typography>
            </Popover>
        </>
    );
};


//
const Sidebar = () => {
    const [sidebarWidth, setSidebarWidth] = useState(74); // Initial width of the sidebar
    const [sidebarActive, setSidebarActive] = useState(true);
    const [hoveredIcon, setHoveredIcon] = useState(null);
    // const userDetails = useSelector(state => state.auth.userDetails) || {}
    const userDetails = Cookies.get('userDetails') ? JSON.parse(Cookies.get('userDetails')) : null;
    // const userDetails = {
    //   isSuperUser:1
    // };  
    console.log("UserDetails :: ",userDetails)
    // const popoverRef = useRef();
    const [anchorEl, setAnchorEl] = useState(null);

    const dispatch = useDispatch()
    const orderMenuItems = [
        { label: 'Incoming Orders', path: '/inbox-order' },
        { label: 'Outgoing Orders', path: '/outbox-order' },
    ];
    const { t } = useTranslation();

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    // const o = Boolean(anchorEl);
    // const id = o ? 'simple-popover' : undefined;
    const o = Boolean(anchorEl);

    useEffect(() => {
        setSidebarActive(true);

    }, []);

    useEffect(() => {
        // var popover = new Popover(popoverRef.current, {
        //     content: "Hello popover content!",
        //     title: "My Popover",
        //     trigger: 'hover'
        // })
    }, [])

    // Function to handle hover
    const handleIconHover = (iconName) => {
        setHoveredIcon(iconName);
    };

    const toggleSidebar = () => {
        // Toggle between half and full width
        const newWidth = sidebarWidth === 74 ? 205 : 74;
        setSidebarWidth(newWidth);
        setSidebarActive(!sidebarActive);
        console.log("sidebarActive", sidebarActive ? open(true) : close(false)
        );
        sidebarActive ? dispatch(open()) : dispatch(close())

        // localStorage.setItem(sidebarActive, JSON.stringify(sidebarActive));

    };
    const buttonStyle = {
        marginLeft: sidebarActive ? `${sidebarWidth}px` : '205px',
    };
    // console.log('USER DETAILS :::>>>',     )
    return (
      <div className="container-fluid page-body-wrapper pt-0">
        {/* Side-Nav */}
        <div
          className={`side-navbar sidebar bgmask ${sidebarActive ? "active-nav sidebar-icon-only" : ""}`}
          id="sidebar"
          style={{ width: sidebarWidth + "px" }}
        >
          {/* Your sidebar content */}
          {userDetails?.data.user.userType == "admin" ? (
            <ul className="nav flex-column text-white w-100">
              {/* Company */}

              <li
                className={`nav-item ${hoveredIcon === "company" ? "hovered" : ""}`}
                onMouseEnter={() => handleIconHover("company")}
                onMouseLeave={() => handleIconHover(null)}
              >
                {sidebarWidth === 205 ? (
                  <>
                    <a
                      className="nav-link"
                      data-bs-toggle="collapse"
                      data-bs-target="#ui-company"
                      aria-controls="ui-company"
                    >
                      <img src={admincompany} alt="Company" />

                      <span className="">Orders</span>
                      {/* {t('navigation.orders')} */}
                    </a>

                    <div className="collapse" id="ui-company">
                      <ul className="nav flex-column sub-menu">
                        <li className="nav-item">
                          {" "}
                          <NavLink
                            className="nav flex-column sub-menu nav-link"
                            to="/active-orders"
                          >
                            Active Orders
                          </NavLink>
                        </li>
                        {/* {t('navigation.incomingOrders')} */}
                        <li className="nav-item">
                          {" "}
                          <NavLink
                            className="nav flex-column sub-menu nav-link"
                            to="/pending-orders"
                          >
                            Pending Orders
                          </NavLink>
                        </li>
                        <li className="nav-item">
                          {" "}
                          <NavLink
                            className="nav flex-column sub-menu nav-link"
                            to="/pending-orders"
                          >
                            Complete Orders
                          </NavLink>
                        </li>
                      </ul>
                    </div>
                  </>
                ) : (
                  <>
                    <NavLink to="/active-orders" className="nav-link">
                      <img src={admincompany} alt="" />
                    </NavLink>
                  </>
                )}
              </li>
              {/* Business Unit */}
              <li
                className={`nav-item ${hoveredIcon === "buunit" ? "hovered" : ""}`}
                onMouseEnter={() => handleIconHover("buunit")}
                onMouseLeave={() => handleIconHover(null)}
              >
                {sidebarWidth === 205 ? (
                  <NavLink to="/product-category" className="nav-link">
                    <i className="bx bxs-buunit">
                      <img src={buUniticons} alt="Outgoing" />
                    </i>
                    <span className="">Categories</span>
                    {/* {t('navigation.buunit')} */}
                  </NavLink>
                ) : (
                  <NavLink to="/product-category" className="nav-link">
                    <img src={buUniticons} alt="" />
                  </NavLink>
                )}
              </li>

              {/* Users */}
              <li className="nav-item">
                {sidebarWidth === 205 ? (
                  <NavLink to="/users" className="nav-link">
                    <i>
                      <img src={usersicon} alt="Outgoing" />
                    </i>
                    <span className="">Users - Management</span>
                    {/* {t('navigation.users')} */}
                  </NavLink>
                ) : (
                  <NavLink to="/users" className="nav-link">
                    <img src={usersicon} alt="" />
                  </NavLink>
                )}
              </li>

              {/* Products */}
              <li className="nav-item">
                {sidebarWidth === 205 ? (
                  <NavLink to="/products" className="nav-link">
                    <i>
                      <img src={producticon} alt="Products" />
                    </i>
                    <span className="">Products</span>
                    {/* {t('navigation.products')} */}
                  </NavLink>
                ) : (
                  <NavLink to="/products" className="nav-link">
                    <img src={producticon} alt="#" className="producticon" />
                  </NavLink>
                )}
              </li>
              {/* Subscription Plan */}
              <li
                className={`nav-item ${hoveredIcon === "company" ? "hovered" : ""}`}
                onMouseEnter={() => handleIconHover("company")}
                onMouseLeave={() => handleIconHover(null)}
              >
                {sidebarWidth === 205 ? (
                  <>
                    <a
                      className="nav-link"
                      data-bs-toggle="collapse"
                      data-bs-target="#ui-processloss"
                      aria-controls="ui-processloss"
                    >
                      <img src={processlosicon} alt="Process loss" />

                      <span className="">Subscription Plan</span>
                      {/* {t('navigation.orders')} */}
                    </a>

                    <div className="collapse" id="ui-processloss">
                      <ul className="nav flex-column sub-menu">
                        <li className="nav-item">
                          {" "}
                          <NavLink
                            className="nav flex-column sub-menu nav-link"
                            to="/regular-plan"
                          >
                            Regular Plan
                          </NavLink>
                        </li>
                        {/* {t('navigation.incomingOrders')} */}
                        <li className="nav-item">
                          {" "}
                          <NavLink
                            className="nav flex-column sub-menu nav-link"
                            to="/special-plan"
                          >
                            Special / Festival Plan
                          </NavLink>
                        </li>
                      </ul>
                    </div>
                  </>
                ) : (
                  <>
                    <NavLink to="/active-orders" className="nav-link">
                      <img src={processlosicon} alt="" />
                    </NavLink>
                  </>
                )}
              </li>
              {/* Discount Management */}
              <li className="nav-item">
                {sidebarWidth === 205 ? (
                  <NavLink to="/coupen-list" className="nav-link">
                    <i>
                      <img src={adminreporticon} alt="#" />
                    </i>
                    <span className="">Coupons</span>
                  </NavLink>
                ) : (
                  <NavLink to="/coupen-list" className="nav-link">
                    <img src={adminreporticon} alt="#" />
                  </NavLink>
                )}
              </li>

              {/* Festival Banner Content */}
              <li className="nav-item">
                {sidebarWidth === 205 ? (
                  <NavLink to="/festival-list" className="nav-link">
                    <i>
                      <img src={bannercontenticon} alt="Banner Content" />
                    </i>
                    <span className="">Festival Promotions</span>
                    {/* {t('navigation.bannerContent')} */}
                  </NavLink>
                ) : (
                  <NavLink to="/festival-list" className="nav-link">
                    <img src={bannercontenticon} alt="#" />
                  </NavLink>
                )}
              </li>
              {/* Logout */}
              <li className="nav-item">
                {sidebarWidth === 205 ? (
                  <NavLink to="/logout" className="nav-link">
                    <i>
                      <img src={logouticon} alt="Logout" />
                    </i>
                    <span className="">Logout</span>
                  </NavLink>
                ) : (
                  <NavLink to="/logout" className="nav-link">
                    <img src={logouticon} alt="#" />
                  </NavLink>
                )}
              </li>
            </ul>
          ) : // All VCP
          userDetails?.isMarketingLab == 1 ||
            userDetails?.isMarketingTracer == 1 ? (
            <ul className="nav flex-column text-white w-100">
              {/* sourceverification */}
              <li className="nav-item">
                {sidebarWidth === 205 ? (
                  <NavLink to="trf" className="nav-link">
                    <i>
                      <img
                        src={sourceverificationicon}
                        alt="Source Verification"
                      />
                    </i>
                    <span className="">
                      {t("navigation.sourceVerification")}
                    </span>
                  </NavLink>
                ) : (
                  <NavLink to="trf" className="nav-link">
                    <img
                      src={sourceverificationicon}
                      alt="#"
                      className="sourceverification-icon"
                    />
                  </NavLink>
                )}
              </li>
              {/* change Password */}
              {/* <li className="nav-item">
                {sidebarWidth === 205 ? (
                  <NavLink to="/sourceverification" className="nav-link">
                    <i>
                      <img
                        src={sourceverificationicon}
                        alt="Source Verification"
                      />
                    </i>
                    <span className="">Watch a Video</span>
                  </NavLink>
                ) : (
                  <NavLink to="/sourceverification" className="nav-link">
                    <img
                      src={sourceverificationicon}
                      alt="#"
                      className="sourceverification-icon"
                    />
                  </NavLink>
                )}
              </li> */}
              {/* watch a video */}
              {/* <li className="nav-item">
                                {sidebarWidth === 205 ? (
                                    <NavLink to="/sourceverification" className="nav-link">
                                        <i ><img src={sourceverificationicon} alt="Source Verification" />
                                        </i>
                                        <span className="">{t('navigation.sourceVerification')}</span>
                                    </NavLink>
                                ) : (
                                    <NavLink to="/sourceverification" className="nav-link">
                                        <img src={sourceverificationicon} alt="#" className="sourceverification-icon" />
                                    </NavLink>
                                )}
                            </li> */}
            </ul>
          ) : (
            <ul className="nav flex-column text-white w-100">
              {/* Dashboard */}
              <li
                className={`nav-item ${hoveredIcon === "dashboard" ? "hovered" : ""}`}
                onMouseEnter={() => handleIconHover("dashboard")}
                onMouseLeave={() => handleIconHover(null)}
              >
                {sidebarWidth === 205 ? (
                  <NavLink to="/dashboard" className="nav-link">
                    <i>
                      <img
                        src={dashbordHovered}
                        alt="Dashboard"
                        className="dashboard-icon"
                      />
                    </i>
                    <span className="">{t("navigation.dashboard")}</span>
                  </NavLink>
                ) : (
                  <NavLink to="/dashboard" className="nav-link">
                    <img
                      src={dashbordicon}
                      alt=""
                      className="dashbord-icon-g"
                    />
                  </NavLink>
                )}
              </li>
              {/*Orders  */}
              <li
                className={`nav-item ${hoveredIcon === "orders" ? "hovered" : ""}`}
                onMouseEnter={() => handleIconHover("orders")}
                onMouseLeave={() => handleIconHover(null)}
              >
                {sidebarWidth === 205 ? (
                  <>
                    <a
                      className="nav-link"
                      data-bs-toggle="collapse"
                      data-bs-target="#ui-Order"
                      aria-controls="ui-Order"
                    >
                      <img src={ordersicon} alt="Orders" />

                      <span className="">Orders</span>
                    </a>

                    <div className="collapse" id="ui-Order">
                      <ul className="nav flex-column sub-menu">
                        {userDetails?.company?.companyRoles !== "BR" ? (
                          <>
                            <li className="nav-item">
                              {" "}
                              <NavLink
                                className="nav flex-column sub-menu nav-link"
                                to="/assigned-orders"
                              >
                                Allocated Orders
                              </NavLink>
                            </li>
                            <li className="nav-item">
                              {" "}
                              <NavLink
                                className="nav flex-column sub-menu nav-link"
                                to="/unassigned-orders"
                              >
                                Not Assign Orders
                              </NavLink>
                            </li>
                            <li className="nav-item">
                              {" "}
                              <NavLink
                                className="nav flex-column sub-menu nav-link"
                                to="/manual-assign-orders"
                              >
                                Manual Assign Orders
                              </NavLink>
                            </li>
                          </>
                        ) : (
                          // (
                          //     <NavLink to="/outbox-order" className="nav-link">
                          //         <img src={ordersicon} alt="" />
                          //     </NavLink>
                          // )
                          <li className="nav-item">
                            {" "}
                            <NavLink
                              className="nav flex-column sub-menu nav-link"
                              to="/assigned-orders"
                            >
                              Allocated Orders
                            </NavLink>
                          </li>
                        )}
                      </ul>
                    </div>
                  </>
                ) : (
                  <NavLink to="/outbox-order" className="nav-link">
                    <img src={ordersicon} alt="" />
                  </NavLink>
                )}
              </li>
              {/* Managers */}
              <li className="nav-item">
                {sidebarWidth === 205 ? (
                  <NavLink to="managers-list" className="nav-link">
                    <i>
                      <img src={stockicon} alt="Outgoing" />
                    </i>
                    <span className="">Managers</span>
                  </NavLink>
                ) : (
                  <NavLink to="managers-list" className="nav-link">
                    <img src={stockicon} alt="" />
                  </NavLink>
                )}
              </li>
              {/* Delivery - Boys  */}
              <li
                className={`nav-item ${hoveredIcon === "shipment" ? "hovered" : ""}`}
                onMouseEnter={() => handleIconHover("shipment")}
                onMouseLeave={() => handleIconHover(null)}
              >
                {sidebarWidth === 205 ? (
                  <>
                    <a
                      className="nav-link"
                      data-bs-toggle="collapse"
                      data-bs-target="#ui-Shipment"
                      aria-controls="ui-Shipment"
                    >
                      <img src={shipmenticon} alt="Shipments" />

                      <span className="">Delivery Boys</span>
                    </a>

                    <div className="collapse" id="ui-Shipment">
                      <ul className="nav flex-column sub-menu">
                        {/* {userDetails?.company?.companyRoles != 'PF' && */}
                        <li className="nav-item">
                          {" "}
                          <NavLink
                            className="nav flex-column sub-menu nav-link"
                            to="/ok-delivery-boy"
                          >
                            Registered Delivery Boys
                          </NavLink>
                        </li>
                        {/* }
                                        {userDetails?.company?.companyRoles != 'BR' && */}
                        <li className="nav-item">
                          {" "}
                          <NavLink
                            className="nav flex-column sub-menu nav-link"
                            to="/unchecked-delivery-boy"
                          >
                            New Un - Registered Delivery Boys
                          </NavLink>
                        </li>
                        {/* } */}
                      </ul>
                    </div>
                  </>
                ) : (
                  <NavLink to="/ok-delivery-boy" className="nav-link">
                    <img src={shipmenticon} alt="" />
                  </NavLink>
                )}
              </li>

              {/* Delivery Boys */}
              {/* <li className="nav-item">
                {sidebarWidth === 205 ? (
                  <NavLink to="/delivery-boys-list" className="nav-link">
                    <i>
                      <img src={stockicon} alt="Outgoing" />
                    </i>
                    <span className="">Delivery Boys</span>
                  </NavLink>
                ) : (
                  <NavLink to="/delivery-boys-list" className="nav-link">
                    <img src={stockicon} alt="" />
                  </NavLink>
                )}
              </li> */}
              {/* Vehical  */}
              <li className="nav-item">
                {sidebarWidth === 205 ? (
                  <NavLink to="/vehical-list" className="nav-link">
                    <i>
                      <img src={stockicon} alt="Outgoing" />
                    </i>
                    <span className="">Registered Vehical</span>
                  </NavLink>
                ) : (
                  <NavLink to="/vehical-list" className="nav-link">
                    <img src={stockicon} alt="" />
                  </NavLink>
                )}
              </li>

              {/* Manager Profile */}
              <li className="nav-item">
                {sidebarWidth === 205 ? (
                  <NavLink to="/manager-profile" className="nav-link">
                    <i>
                      <img src={partnerProfileIcon} alt="Partner Profile" />
                    </i>
                    <span className="">Manager Profile</span>
                  </NavLink>
                ) : (
                  <NavLink to="/manager-profile" className="nav-link">
                    <img src={partnerProfileIcon} alt="#" className="" />
                  </NavLink>
                )}
              </li>
              {/* Drop - Points / Vendor Details */}
              <li className="nav-item">
                {sidebarWidth === 205 ? (
                  <NavLink to="/drop-point-list" className="nav-link">
                    <i>
                      <img src={sourceverificationicon} alt="Drop Points" />
                    </i>
                    <span className="">Drop - Points list</span>
                  </NavLink>
                ) : (
                  <NavLink to="/drop-point-list" className="nav-link">
                    <img
                      src={sourceverificationicon}
                      alt="#"
                      className="sourceverification-icon"
                    />
                  </NavLink>
                )}
              </li>

              {/* Vendors */}
              <li className="nav-item">
                {sidebarWidth === 205 ? (
                  <NavLink to="/vendor-details" className="nav-link">
                    <i>
                      <img src={requesttagicon} alt="Outgoing" />
                    </i>
                    <span className="">Vendors Details</span>
                  </NavLink>
                ) : (
                  <NavLink to="/vendor-details" className="nav-link">
                    <img src={requesttagicon} alt="#" />
                  </NavLink>
                )}
              </li>
              {/* Users */}
              <li className="nav-item">
                {sidebarWidth === 205 ? (
                  <NavLink to="/user-management" className="nav-link">
                    <i>
                      <img src={stockicon} alt="user-management" />
                    </i>
                    <span className="">Users- Management</span>
                  </NavLink>
                ) : (
                  <NavLink to="/user-management" className="nav-link">
                    <img src={stockicon} alt="" />
                  </NavLink>
                )}
              </li>
              {/* {userDetails?.company?.companyTypeName == "Brand" ? (
                <li className="nav-item">
                  {sidebarWidth === 205 ? (
                    <NavLink to="/audit-trail" className="nav-link">
                      <i>
                        <img src={auditIcon} alt="Audit Trail" />
                      </i>
                      <span className="">Audit Trail</span>
                    </NavLink>
                  ) : (
                    <NavLink to="/audit-trail" className="nav-link">
                      <img src={auditIcon} alt="#" />
                    </NavLink>
                  )}
                </li>
              ) : null}
              <li className="nav-item">
                {sidebarWidth === 205 ? (
                  <NavLink to="/about" className="nav-link">
                    <i>
                      <img src={companyprofileicon} alt="Outgoing" />
                    </i>
                    <span className="">{t("navigation.aboutUs")}</span>
                  </NavLink>
                ) : (
                  <NavLink to="/about" className="nav-link">
                    <img src={companyprofileicon} alt="#" />
                  </NavLink>
                )}
              </li>
            */}
            </ul>
          )}

          <Button
            variant="outline-secondary"
            id="menu-btn"
            onClick={toggleSidebar}
            style={buttonStyle}
          >
            <ArrowRightAltOutlinedIcon color="white" background-color="green" />
          </Button>
        </div>
      </div>
    );
};
export default Sidebar;
